<template lang="pug">
.register-content
  v-stepper(v-model='e6', vertical='' non-linear=true)
    v-stepper-step(:complete='e6 > 1', step='1' :editable='edit')
      | Información del usuario
      small Ingresa la información personal para el nuevo usuario
    v-stepper-content(step='1')
      v-card.mb-12#user-data
        template
          v-text-field(v-model='user.name' :error-messages='nameErrors' :counter='50' label='Nombre' required='' :rules="nameRules")
          v-text-field(v-model='user.lastName' :error-messages='nameErrors' :counter='50' label='Apellidos' required='' :rules="nameRules")
          v-text-field(v-model='user.email' type='email' :error-messages='emailErrors' label='E-mail' :counter='100' required='' :rules="emailRules")
          v-text-field(v-model='user.age' :counter='4' label='Edad' )
          v-select(v-model='user.gender' :items='gens' :error-messages='selectErrorsGenm' label='Género' required='')
          v-text-field(v-model='pass' :error-messages='nameErrors' :counter='50' label='Password' required='' :rules="nameRules" type='password')
      v-btn(@click='clear("user")') Limpiar
      v-btn(color='primary', @click='e6 = 2') Continuar
    //- v-stepper-step(:complete='e6 > 2', step='2' :editable='edit') Institución
    //- v-stepper-content(step='2')
    //-   v-card.mb-12
    //-     template#institute-data
    //-       small Verifique que el instituto que esta por agregar no exista
    //-       v-combobox(v-model='user.institute.name' :items='institutes' label='Instituto' :error-messages='institutesError'  required='' :cleareable='clearInst' :rules="nameRules")

    //-   v-btn(color='primary', @click='e6 = 3') Continuar
    //- v-stepper-step(:complete='e6 > 3', step='3' :editable='edit') Información adicional
    //- v-stepper-content(step='3')
    //-   v-card.mb-12
    //-     v-card.mb-12
    //-     template#institute-data
    //-       small ¿Has tomado cursos de inglés en los dos años anteriores? Sí es así, ¿Cuales?
    //-       v-combobox(v-model='user.courses' multiple :items='courses' label='Instituto')

    //-   v-btn(color='primary', @click='e6 = 4') Continuar
    v-stepper-step(step='2') Verica que todos los Datos esten correctos
    v-stepper-content(step='2')
      v-card.mb-12
      v-btn(text='') Cancelar
      v-btn(color='success', @click='save()' :loading='loading') Registrar
  v-card(v-if='msg_global')
    v-banner(v-model='msg_global' single-line='' transition='slide-y-transition')
      | {{ msg_global_txt }}
      template(v-slot:actions='{ dismiss }')
        v-btn(text='' color='primary' @click='goLogin()') Ir al Login

</template>


<script>
  import { config } from '../config.js'

  export default {

    data () {
      return {
        e6: 1,
        msg_global_txt:'',
        msg_global:false,
        clearInst: true,
        edit: true,
        loading: false,
        select:'',
        pass:'',
        courses:['TOEFL', 'IELTS'],
        gens:['Masculino','Femenino'],
        institutes:[
          'ITESM',
          'UNAM',
          'IPN'
        ],
        user:{
          id: '',
          name:'',
          lastName:'',
          email:'',
          age:'',
          gender:'',
          courses: [],
          institute: {
            name:''
          },
          groups:[]
        },
        nameErrors: '',
        emailErrors: '',
        institutesError: '',
        selectErrorsGenm: '',
        nameRules: [
          v => !!v || 'Name is required',
          v => (v && v.length <= 100) || 'Name must be less than 100 characters',
        ],
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],

      }
    },
    mounted(){
      console.log('Props: ', this.$route.query.token);
      this.$emit("loadingEvent", true);
      let token = this.$route.query.token;

      this.axios.get(`${config.serviceUri}users?service=validate&id=${token}`)
        .then( (response) => {
            debugger;
            console.log('Succes request: ',response.data);
            this.user.id = token;
            this.user.groups = response.data.payload.groups;
            this.$emit("loadingEvent", false);
        })
        .catch( (error) => {
            console.log('Error: ', error);
            this.$router.push({ name: 'home' });
            this.$emit("loadingEvent", false);
        });

      
    },
    methods: 
    {
      goLogin(){
        this.$router.push({ name: 'home' });
      },
      clear(formV){
        switch(formV) {
          case 'user' : {
            this.user.name = '';
            this.user.email = '';
            this.user.age = '';
            this.user.lastName = '';
            break;
          }
        }
      },
      save(){
        this.$emit("loadingEvent", true);

        let _this = this;
        _this.loading = true;
        let gen_user = {
          user_key: this.pass,
          user: {
            id: _this.user.id,
            name: _this.user.email,
            active: true
          }
        }
        debugger;

        // userUpdate
        this.axios.patch(`${config.serviceUri}users?id=${_this.user.id}`, gen_user)
        .then( (response) => {
            console.log('Succes User create: ',response.data);
            
            _this.axios.post(`${config.serviceUri}students?userid=${_this.user.id}`, {
              userId: _this.user.id,
              name: _this.user.name,
              lastName: _this.user.lastName,
              institute: _this.user.institute,
              gender: _this.user.gender,
              age:_this.user.age,
              courses: _this.user.courses,
              email: _this.user.email,
              groups: _this.user.groups ? _this.user.groups : [],
              groups_ids: _this.user.groups ? _this.user.groups.map(g => g.id) : []
            })
            .then( (response) => {
                console.log('Succes Student create: ',response.data);
                this.msg_global = true;
                this.msg_global_txt = 'Usuario creado con exito';
                this.loading = false;
                this.$emit("loadingEvent", false);
            })
            .catch( (error) => {
                console.log('Error: ', error);
                this.loading = false;
                this.msg_global = true;
                this.msg_global_txt = 'Ocurrio un problem al crear tu usario intentalo mas tarde o contacta con el administrador';
                this.$emit("loadingEvent", false);
            });
            
        })
        .catch( (error) => {
            console.log('Error: ', error);
            this.loading = false;
            this.msg_global = true;
            this.msg_global_txt = 'Ocurrio un problem al crear tu usario intentalo mas tarde o contacta con el administrador';
            this.$emit("loadingEvent", false);
        });
      }
    }
  }
</script>

<style scoped>
  .v-card{
    box-shadow: none;
  }

  .v-btn{
    margin: 0 5px;
  }

  #user-data{
    display: flex;
    flex-wrap: wrap;
  }

  #user-data > .v-input{
    flex: 0 40%;
    width: 100%;
    margin: auto 5px;
  }

</style>

